import { Injectable } from '@angular/core';
import { StairLandingBothSidesService } from './stair-landing-both-sides.service';
import { StairLandingStraightService } from './stair-landing-straight.service';
import { StairLandingRightService } from './stair-landing-right.service';
import { StairLandingLeftService } from './stair-landing-left.service';
import { StraightStairService } from './straight-stairs.service';
import { StageService } from './stage.service';
import { ConstantsService } from './constants.service';
declare const THREE: any;

@Injectable()
export class StairRebuildService {
  constructor(
    private straightStairService: StraightStairService,
    private stairLandingLeftService: StairLandingLeftService,
    private stairLandingRightService: StairLandingRightService,
    private stairLandingStraightService: StairLandingStraightService,
    private stairLandingBothSidesService: StairLandingBothSidesService,
    private stageService: StageService,
    private constantsService: ConstantsService
  ) {}

  rebuildStairsForFasciaMount() {
    const floor = this.stageService.getCompoundFloor();
    const rebuildedStairs = [];
    floor.children.forEach(tier => {
      tier.userData.points.forEach(point => {
        const hasSuperstructureType: boolean = point.superstructureType ? true : false;
        if (hasSuperstructureType) {
          const superstructure = point.superstructureType;
          if (superstructure.includes('tair')) {
            if (point.superstructure) {
              const config = point.superstructure.userData.config;
              const rebuildedStair = this.rebuildStair(config);
              if (rebuildedStair) {
                rebuildedStairs.push(rebuildedStair);
              }
            }
          }
        }
      });
      for (let i = 0; i < tier.userData.points.length; i++) {
        const hasSuperstructureType = tier.userData.points[i].superstructureType ? true : false;
        if (hasSuperstructureType) {
          const superstructure = tier.userData.points[i].superstructureType;
          if (
            superstructure.includes('tier') &&
            !superstructure.includes('tier1') &&
            tier.userData.points[i].parent
          ) {
            const stairs = tier.children.find(child => child.name === 'tierSteps');
            const fPoint = tier.userData.points[i];
            const sPoint = tier.userData.points[(i + 1) % tier.userData.points.length];
            const rebuildedStair = this.rebuildTierSteps(
              fPoint,
              sPoint,
              tier.userData.parentCustomId,
              tier.userData.customId,
              fPoint.superstructureType,
              stairs
            );
            if (rebuildedStair) {
              rebuildedStairs.push(rebuildedStair);
            }
          }
        }
      }
    });
    return rebuildedStairs;
  }

  rebuildStair(config) {
    const fp = new THREE.Vector3(config.firstPoint.x, 0, config.firstPoint.y);
    const sp = new THREE.Vector3(config.secondPoint.x, 0, config.secondPoint.y);
    const rebuildData = this.checkDistanceToCorners(fp, sp, config.width, config.distance);
    // const stair = this.stageService.getObjectById(config.superstructureId);
    if (rebuildData) {
      config.width = rebuildData.width;
      config.distance = rebuildData.distance;
      config.firstPoint.width = rebuildData.width;
      config.oldstair = this.stageService.getObjectById(config.superstructureId);
      let result = Promise.resolve(null);
      switch (config.superstructureType) {
        case 'straightStair':
          result = this.straightStairService.build(config);
          break;
        case 'stairLandingLeft':
          result = this.stairLandingLeftService.build(config);
          break;
        case 'stairLandingRight':
          result = this.stairLandingRightService.build(config);
          break;
        case 'stairLandingStraight':
          result = this.stairLandingStraightService.build(config);
          break;
        case 'stairLandingBothSides':
          result = this.stairLandingBothSidesService.build(config);
          break;
      }
      return result;
    } else {
      return null;
    }
  }

  private checkDistanceToCorners(fp, sp, width, distance) {
    const length = fp.distanceTo(sp);
    const needStairRebuild =
      length - (distance + width / 2) < 30 || distance - width / 2 < 30 ? true : false;
    const newWidth = width > length - 60 ? length - 60 : width;
    let offsetLeft =
      length - (distance + width / 2) < 30 ? length - (distance + width / 2) - 30 : 0;
    let offsetRight = distance - width / 2 < 30 ? 30 - (distance - width / 2) : 0;
    let offset = 0;
    if (offsetLeft) {
      //offset = length/2 - this.constantsService.minimalSpaceForStairsOnSIde + newWidth/2;
      offset = distance - length / 2;
    } else if (offsetRight) {
      // offset = -this.constantsService.minimalSpaceForStairsOnSIde - length/2 + distance;
      offset = distance - length / 2;
    }
    offset = offsetLeft && offsetRight ? 0 : offset;
    if (needStairRebuild) {
      return {
        width: newWidth,
        distance: length / 2,
        offset: offset
      };
    } else {
      return null;
    }
  }

  private rebuildTierSteps(point, secondPoint, parentTierId, tierId, superstructureType, steps) {
    const parentTier = this.stageService
      .getCompoundFloor()
      .children.find(tier => tier.userData.customId === parentTierId);
    const parentFirstPointIndex = parentTier.userData.points.findIndex(
      point => point.childCustomId === tierId
    );
    const parentFPoint = parentTier.userData.points[parentFirstPointIndex];
    const parentFirstPoint = new THREE.Vector3(parentFPoint.x, 0, parentFPoint.y);
    const parentSecondPointIndex =
      parentFirstPointIndex + 1 === parentTier.userData.points.length
        ? 0
        : parentFirstPointIndex + 1;
    const parentSPoint = parentTier.userData.points[parentSecondPointIndex];
    const parentSecondPoint = new THREE.Vector3(parentSPoint.x, 0, parentSPoint.y);
    const fp = new THREE.Vector3(point.x, 0, point.y);
    const sp = new THREE.Vector3(secondPoint.x, 0, secondPoint.y);
    const distanceBtwTiers = Math.pow(
      this.constantsService.tierTypeSettingsMap[superstructureType].distanceToTier,
      2
    );
    const nearestFp =
      sp.distanceTo(fp) <=
      Math.sqrt(Math.pow(sp.distanceTo(parentSecondPoint), 2) - distanceBtwTiers)
        ? fp
        : parentSecondPoint;
    const nearestSp =
      fp.distanceTo(sp) <=
      Math.sqrt(Math.pow(fp.distanceTo(parentFirstPoint), 2) - distanceBtwTiers)
        ? sp
        : parentFirstPoint;
    const rebuildData = this.checkDistanceToCorners(
      nearestFp,
      nearestSp,
      point.width,
      point.distance
    );
    const direction = new THREE.Vector3(nearestFp.x - nearestSp.x, 0, nearestFp.z - nearestSp.z);
    let result = null;
    if (rebuildData) {
      point.width = rebuildData.width;
      point.distance = rebuildData.distance;
      direction.setLength(rebuildData.offset);
      result = new Promise((resolve, reject) => {
        steps.children.forEach(step => {
          step.position.add(direction);
          step.scale.x = rebuildData.width / this.constantsService.inermediateStepSize.width;
        });
        resolve();
      });
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/stair-rebuild.service.ts